module.exports = "/_next/static/images/verifiedFavicon.external-d536786722a9244f768022a9803ee558.svg";